import * as React from 'react';
import { StackLayout } from '@leagueplatform/genesis-core';
import { NavItem, NavItemProps } from './nav-item/nav-item.component';

export type SideNavProps = {
  items: NavItemProps[];
};

export const SideNav = ({ items }: SideNavProps) => (
  <nav>
    <StackLayout as="ul" spacing="$quarter" horizontalAlignment="stretch">
      {items.map((item) => (
        <NavItem
          key={item.path}
          name={item.name}
          icon={item.icon}
          path={item.path}
          isActive={item.isActive}
          hasLandingPage={item.hasLandingPage}
          navItems={item.navItems}
        />
      ))}
    </StackLayout>
  </nav>
);
